import BaseStore from './BaseStore';
import DaqLocationModel from "../models/DaqLocationModel";

export default class DaqLocation extends BaseStore {
  constructor(transportLayer) {
    super(DaqLocationModel, transportLayer);
  }
};


// WEBPACK FOOTER //
// ./src/stores/DaqLocationStore.js